// @flow
import { createSelector } from "reselect"

import { getJourney } from "booking/services/journey/reducer"
import Price from "common/records/Price"
import createAncillaryReducer from "../reducer"
import { serviceApplicableSelector, servicePriceSelector, serviceAddedSelector } from "../selectors"

const airHelpReducer = createAncillaryReducer("airHelp")

export default airHelpReducer

export const originalAirHelpEnabled: $FlowFixMe = createSelector(
  state => state.splitster,
  splitster => splitster.get("AIR_HELP_PLUS").value === "original",
)

export const airHelpWithBadgeEnabled: $FlowFixMe = createSelector(
  state => state.splitster,
  splitster => splitster.get("AIR_HELP_PLUS").value === "withBadge",
)

export const isAirHelpApplicableSelector: $FlowFixMe = createSelector(
  serviceApplicableSelector("airHelp"),
  getJourney,
  (applicable, journey) => applicable && journey.hasFlight(),
)

export const getAirHelpPrice = servicePriceSelector("airHelp")

export const airHelpAddedSelector = serviceAddedSelector("airHelp")

export const airHelpOrderedPriceSelector: $FlowFixMe = createSelector(
  getAirHelpPrice,
  airHelpAddedSelector,
  (airHelpPriceInfo, airHelpAdded) => (airHelpAdded ? airHelpPriceInfo : new Price({ amount: 0 })),
)
